import { Injectable } from '@angular/core';
import { BaseResourceService } from '@zag/ui';
import { type PersonResponse } from '@zag/core/models';

@Injectable({ providedIn: 'root' })
export class PersonService extends BaseResourceService<PersonResponse> {
  protected readonly basePath = '/api/v1/core/persons';
}
